// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lucky_lucky__ryUmW {
  min-height: 100dvh;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  width: 100%;
}
.lucky_inner__tXFXe {
  width: 100%;
  padding: 0 16px;
  margin-top: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 500px;
}
.lucky_no-winner__rpWKS {
}
.lucky_wrapper__X7V6F {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
}
.lucky_items__ZW-y9 {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 4px;
}
.lucky_item__7Kes1 {
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.1);
  box-shadow: -105px 67px 35px 0px rgba(0, 3, 15, 0),
    -67px 43px 32px 0px rgba(0, 3, 15, 0.01),
    -38px 24px 27px 0px rgba(0, 3, 15, 0.04),
    -17px 11px 20px 0px rgba(0, 3, 15, 0.07),
    -4px 3px 11px 0px rgba(0, 3, 15, 0.08);
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 56px;
  color: #fff;
  /* font-family: Yekan Bakh VF; */
  font-size: 14px;
  font-style: normal;
  font-weight: 450;
  line-height: 21px;
  letter-spacing: -0.32px;
  padding: 0 16px;
  gap: 40px;
}

.lucky_phone__yXDh1 {
  direction: ltr;
}
.lucky_counter__ax5UZ {
  background: #fe4f2d;
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 16px;
  font-weight: 875;
}
.lucky_placeholder__9VGz8 div {
  height: 56px !important;
  border-radius: 8px !important;
}
.lucky_tabs__9xhgZ {
  border-radius: 24px;
  background: rgba(255, 255, 255, 0.1);
  overflow: hidden;
  display: flex;
  /* justify-content: center; */
  /* align-items: center; */
  padding: 2px;
  margin-bottom: 16px;
  transition: all 0.2s ease-in-out;
  margin-top: 24px;
  width: fit-content;
}
.lucky_tab__ouv0- {
  color: #fff;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  height: 36px;
  padding: 0 30px;
  border-radius: 47px;
  transition: all 0.2s ease-in-out;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.lucky_tab-active__oSZwt {
  background: #fff;
  font-weight: 600;
  color: #000;
}

.lucky_winners-title__\\+iWiS {
  width: 100%;
  padding: 0 16px;
  margin-top: 24px;
}
@media screen and (min-width: 1200px) {
  .lucky_inner__tXFXe {
    max-width: 1200px;
    margin-top: 40px;
  }
  .lucky_item__7Kes1 {
    width: 24.7%;
    flex-direction: row-reverse;
  }
  .lucky_items__ZW-y9 {
    justify-content: flex-start;
    flex-flow: wrap;
    width: 100%;
    direction: ltr;
  }
  .lucky_lucky__ryUmW {
    justify-content: space-between;
  }
  .lucky_winners-title__\\+iWiS {
    width: auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/lucky/lucky.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;AACA;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,oCAAoC;EACpC;;;;0CAIwC;EACxC,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,gCAAgC;EAChC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,6BAA6B;AAC/B;AACA;EACE,mBAAmB;EACnB,oCAAoC;EACpC,gBAAgB;EAChB,aAAa;EACb,6BAA6B;EAC7B,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,gCAAgC;EAChC,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;AACA;EACE;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,YAAY;IACZ,2BAA2B;EAC7B;EACA;IACE,2BAA2B;IAC3B,eAAe;IACf,WAAW;IACX,cAAc;EAChB;EACA;IACE,8BAA8B;EAChC;EACA;IACE,WAAW;EACb;AACF","sourcesContent":[".lucky {\n  min-height: 100dvh;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  flex-direction: column;\n  width: 100%;\n}\n.inner {\n  width: 100%;\n  padding: 0 16px;\n  margin-top: 24px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  max-width: 500px;\n}\n.no-winner {\n}\n.wrapper {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n}\n.items {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 4px;\n}\n.item {\n  border-radius: 8px;\n  background: rgba(255, 255, 255, 0.1);\n  box-shadow: -105px 67px 35px 0px rgba(0, 3, 15, 0),\n    -67px 43px 32px 0px rgba(0, 3, 15, 0.01),\n    -38px 24px 27px 0px rgba(0, 3, 15, 0.04),\n    -17px 11px 20px 0px rgba(0, 3, 15, 0.07),\n    -4px 3px 11px 0px rgba(0, 3, 15, 0.08);\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  height: 56px;\n  color: #fff;\n  /* font-family: Yekan Bakh VF; */\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 450;\n  line-height: 21px;\n  letter-spacing: -0.32px;\n  padding: 0 16px;\n  gap: 40px;\n}\n\n.phone {\n  direction: ltr;\n}\n.counter {\n  background: #fe4f2d;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 16px;\n  font-weight: 875;\n}\n.placeholder div {\n  height: 56px !important;\n  border-radius: 8px !important;\n}\n.tabs {\n  border-radius: 24px;\n  background: rgba(255, 255, 255, 0.1);\n  overflow: hidden;\n  display: flex;\n  /* justify-content: center; */\n  /* align-items: center; */\n  padding: 2px;\n  margin-bottom: 16px;\n  transition: all 0.2s ease-in-out;\n  margin-top: 24px;\n  width: fit-content;\n}\n.tab {\n  color: #fff;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  height: 36px;\n  padding: 0 30px;\n  border-radius: 47px;\n  transition: all 0.2s ease-in-out;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.tab-active {\n  background: #fff;\n  font-weight: 600;\n  color: #000;\n}\n\n.winners-title {\n  width: 100%;\n  padding: 0 16px;\n  margin-top: 24px;\n}\n@media screen and (min-width: 1200px) {\n  .inner {\n    max-width: 1200px;\n    margin-top: 40px;\n  }\n  .item {\n    width: 24.7%;\n    flex-direction: row-reverse;\n  }\n  .items {\n    justify-content: flex-start;\n    flex-flow: wrap;\n    width: 100%;\n    direction: ltr;\n  }\n  .lucky {\n    justify-content: space-between;\n  }\n  .winners-title {\n    width: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"lucky": `lucky_lucky__ryUmW`,
	"inner": `lucky_inner__tXFXe`,
	"no-winner": `lucky_no-winner__rpWKS`,
	"wrapper": `lucky_wrapper__X7V6F`,
	"items": `lucky_items__ZW-y9`,
	"item": `lucky_item__7Kes1`,
	"phone": `lucky_phone__yXDh1`,
	"counter": `lucky_counter__ax5UZ`,
	"placeholder": `lucky_placeholder__9VGz8`,
	"tabs": `lucky_tabs__9xhgZ`,
	"tab": `lucky_tab__ouv0-`,
	"tab-active": `lucky_tab-active__oSZwt`,
	"winners-title": `lucky_winners-title__+iWiS`
};
export default ___CSS_LOADER_EXPORT___;
